<template>
  <div class="position-relative text-break">
    <custom-select
      v-model="groupId"
      :options="groupOptions"
      toggle-class="mr-0"
      :disabled="fetchingHealthcheckGroups"
    />
    <div
      v-if="fetchingHealthcheckGroups"
      class="position-absolute d-flex justify-content-center align-items-center w-100 h-100"
      style="top: 0;"
    >
      <b-spinner
        small
        variant="primary"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'HealthcheckGroupOptions',
  props: {
    selectedGroupId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      groupId: 0,
      groupOptions: [
        { value: 0, text: 'Uncategorized' },
      ],
    }
  },
  computed: {
    healthcheckGroups() {
      return this.$store.state.healthchecks.healthcheckGroups
    },
    fetchingHealthcheckGroups() {
      return this.$store.state.healthchecks.fetchingHealthcheckGroups
    },
    favGroupId: {
      get() {
        return this.$store.getters['healthchecks/groupId']
      },
      set(value) {
        this.$store.commit('healthchecks/SET_GROUP_ID', value)
      },
    },
  },
  watch: {
    groupId(value) {
      this.$emit('input', value)
    },
  },
  created() {
    this.fetchHealthcheckGroups()
  },
  methods: {
    fetchHealthcheckGroups() {
      this.$store
        .dispatch('healthchecks/fetchHealthcheckGroups', {
          pageIndex: 0,
          pageSize: 200,
        })
        .then(() => { this.orderGroups() })
        .catch(error => {
          this.errorToast(
            error.response?.data?.errors[0]
              || 'Something went wrong while fetching healthcheck groups!',
          )
        })
    },
    orderGroups() {
      const groups = this.healthcheckGroups.sort(a => (a ? 1 : -1))
      const fav = groups.find(a => a.isDefault)
      if (!this.favGroupId) {
        this.favGroupId = fav?.id || 0
      }
      this.groupId = this.selectedGroupId !== null ? this.selectedGroupId : this.favGroupId
      this.$store.commit('healthchecks/SET_SELECTED_GROUP', this.groupId)
      this.groupOptions = [...groups.map(e => ({ value: e.id, text: e.name })), { value: 0, text: 'Uncategorized' }]
    },
  },
}
</script>
